// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--Lu3ou","link":"link--wn0UP","icon":"icon--GloWT","small":"small--iPDDs","medium":"medium--MfONA","large":"large--a89Ug","fadeSlideUp":"fadeSlideUp--SBcsp"};